export default __webpack_public_path__ + "static/media/commercial-vehicle.2d6fb534.png";